module.exports = __webpack_public_path__ + "img/s1-1.acecc9af.svg";